export const useHasUser = () => {
  const user = useSupabaseUser()
  return !!user.value
}
